var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 26,
    viewBox: "0 0 22 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.11779 1.37091C3.89805 0.460909 6.886 0 11 0C19.7357 0 21.6092 2.32227 21.9479 3.705C21.9827 3.84604 22.0002 3.99093 22 4.13636V11.9954C21.9968 16.9052 19.403 21.4325 15.2124 23.8432L11.8516 25.7695C11.3238 26.0768 10.6762 26.0768 10.1484 25.7695L6.78758 23.8432C2.59699 21.4325 0.00324457 16.9052 0 11.9954V4.13636C0 3.74045 0.152842 2.36954 2.11779 1.37091ZM9.80679 15.99C9.96996 16.1559 10.1907 16.2494 10.4211 16.25C10.651 16.249 10.8713 16.1556 11.0342 15.99L17.4026 9.49C17.6349 9.26903 17.7306 8.93625 17.652 8.6222C17.5734 8.30815 17.3331 8.06292 17.0254 7.98272C16.7177 7.90252 16.3917 8.00013 16.1752 8.23727L10.4205 14.1109L6.98153 10.6009C6.63936 10.2755 6.10615 10.2851 5.77544 10.6226C5.44473 10.9602 5.43532 11.5044 5.75416 11.8536L9.80679 15.99Z",
    fill: "#CCCCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.57110226ab7feba0e376237e4c918b4e.svg";
export { ForwardRef as ReactComponent };